export const en = {
    "accept": "Accept",
    "accept-terms-notice": "By clicking “Accept,” you agree to the [Terms of Acceptable Use]",
    'apk-declined': 'Installing this application via the platform is currently unavailable',
    "cancel": "Cancel",
    "check": "Check",
    "device-info": "Apps work differently on various devices. For the Station Duo Max, use versions made for tablets. For YaOS TVs, use apps specifically designed for the TV format.",
    "device-station-duo-max": "Station Duo Max",
    "device-tv-with-yaos": "TV with YaOS",
    "delete-file-question": "Delete file?",
    "delete-file-notice": "Only the installation file will be deleted. The app will remain on the device, but it will no longer appear in YaOS Store.",
    "duo-max": "Duo Max",
    "error": "Error",
    "find-in-my-tab": "You can find them in the YaOS Store under the “My” tab",
    "how-to-install": "How to install an app",
    "install-android-apps": "Install Android apps on your smart devices",
    "max-file-size": "Maximum file size: {maxSize}",
    "my-apps": "My apps",
    "remove-unneeded-apps": "Remove apps you don’t need",
    "select-device-question": "Which device is the app for?",
    "space-free": "{freeSpaceMb} free",
    "space-used": "{spaceAllocatedMb} used of {spaceAvailableGb}",
    "storage-full": "Storage full",
    "terms-of-service": "Terms of service",
    "upload": "Upload",
    "upload-apk-files": "Upload APK files to your device and install them via YaOS Store",
    "upload-apk-files-hint": "Upload files in .apk format",
    "apk-file-expected": "Wrong file format. Upload a file in .apk format",
    "upload-apps": "Upload apps",
    "uploaded-apps-count": "Uploaded app files",
    "yaos-tv": "YaOS TV",

    "tutorial-upload-apk-file": "Upload a file in APK format",
    "tutorial-select-device-for-install": "Select the device you are installing the app for",
    "tutorial-tablet-apps-info": "Tablet apps are suitable for Station Duo Max but do not work on TVs",
    "tutorial-tv-apps-info": "TV apps do not work on Duo Max",
    "tutorial-wait-for-check-complete": "Wait for the check to finish",
    "tutorial-open-yaos-store": "Open YaOS Store on your device",
    "tutorial-go-to-my-section": "Go to the “My” section",
    "tutorial-install-app-instruction": "Install the app — it will appear in the installed apps list",
} as const;
export const ru = {
    "accept": "Принимаю",
    "accept-terms-notice": "Нажимая “Принимаю”, вы соглашаетесь с условиями [Правил допустимого использования]",
    'apk-declined': 'Установка этого приложения через платформу сейчас недоступна',
    "cancel": "Отменить",
    "check": "Проверка",
    "device-info": "Приложения работают по-разному на разных устройствах. Для Станции Дуо Макс подходят версии, сделанные для планшетов. А для телевизоров на YaOS нужны приложения, созданные специально под ТВ-формат.",
    "device-station-duo-max": "Станция Дуо Макс",
    "device-tv-with-yaos": "ТВ с YaOS",
    "delete-file-question": "Удалить файл?",
    "delete-file-notice": "Удаляется только файл установки. Приложение сохранится на устройстве, но в YaOS Store его больше не будет.",
    "duo-max": "Дуо Макс",
    "error": "Ошибка",
    "find-in-my-tab": "Их вы можете найти в YaOS Store во вкладке «Моё»",
    "how-to-install": "Как установить приложение",
    "install-android-apps": "Устанавливайте Android-приложения на ваши умные устройства",
    "max-file-size": "Размер одного файла не больше {maxSize}",
    "my-apps": "Мои приложения",
    "remove-unneeded-apps": "Удалите приложения которые вам не нужны",
    "select-device-question": "Для какого устройства приложение?",
    "space-free": "Свободно {freeSpaceMb}",
    "space-used": "Занято {spaceAllocatedMb} из {spaceAvailableGb}",
    "storage-full": "Закончилось место",
    "terms-of-service": "Правила пользования сервисом",
    "upload": "Загрузить",
    "upload-apk-files": "Загружайте файлы апк на свое устройство, и устанавливайте их через YaOS Store",
    "upload-apk-files-hint": "Загрузите файлы в формате .apk",
    "apk-file-expected": "Неверный формат файла. Загрузите файл в формате .apk",
    "upload-apps": "Загрузить приложения",
    "uploaded-apps-count": "Загруженные файлы приложений",
    "yaos-tv": "YaOS ТВ",

    "tutorial-upload-apk-file": "Загрузите файл в формате APK",
    "tutorial-select-device-for-install": "Выберите устройство, для которого устанавливаете приложение",
    "tutorial-tablet-apps-info": "Приложения для планшетов подходят для Станции Дуо Макс, но не работают на ТВ",
    "tutorial-tv-apps-info": "Приложения для ТВ – не работают на Дуо Макс",
    "tutorial-wait-for-check-complete": "Дождитесь завершения проверки",
    "tutorial-open-yaos-store": "Откройте YaOS Store на вашем устройстве",
    "tutorial-go-to-my-section": "Перейдите в раздел «Моё»",
    "tutorial-install-app-instruction": "Установите приложение — оно появится в списке установленных",
} as const;
